import React from "react";

class LoadingText extends React.Component {
  state = {
    number: 0,
    loading: true
  };

  componentDidMount() {
    this.startLoadingLoop();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  startLoadingLoop = () => {
    this.setState({ number: 0, loading: true });
    this.interval = setInterval(() => {
      this.setState(
        prevState => ({ number: prevState.number + 1 }),
        () => {
          if (this.state.number >= 100) {
            clearInterval(this.interval);
            this.pollStatus(); // fetch backend status when 100% reached
          }
        }
      );
    }, 100);
  };

  pollStatus = async () => {
    try {
      const response = await fetch("/api/status"); // Replace with your real endpoint
      const data = await response.json();

      if (data.status === "done") {
        this.setState({ loading: false });
      } else {
        // Restart loading animation
        this.startLoadingLoop();
      }
    } catch (error) {
      console.error("Polling failed", error);
      // Optionally retry or fail gracefully
      this.startLoadingLoop(); // retry loop on error
    }
  };

  render() {
    const { number, loading } = this.state;

    return (
      <div className="flex-container">
        <h1 className="box-progress" data-text="loading...">
          {loading ? "loading..." : "Finished!"}
        </h1>
        <span className="box-text">
          {loading ? `${number}%` : "✅"}
        </span>
      </div>
    );
  }
}

export default LoadingText;
